import { httpRequest } from "../../http";

export type DeleteOrgMode = "block" | "reparent" | "cascade";

export class CommandDeleteOrganization {
    async run(organizationId: string, mode: DeleteOrgMode = "block") {
        const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}`;
        const url = `${base}?mode=${mode}`;
        try {
            const response = await httpRequest<any>(url, { method: "DELETE" });
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}



